import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import Icon from './Icon';

const prefix = "a-button";

const Button = forwardRef(({
  children,
  className,
  disabled,
  fullwidth = false,
  height = 10,
  pulse = false,
  pulseDuration = 300,
  pulseScale = 105,
  pulseType = "ease-in-out",
  spin,
  ...props
}, ref) => {
  const componentClass = classNames(prefix, "flex flex-wrap flex-column content-center justify-center gap-3", {
    "grayscale-50": disabled,
    "w-[100%]": fullwidth,
    [`h-${height}`]: height,
    [`transition ${pulseType} hover:scale-${pulseScale} duration ${pulseDuration}`]: pulse && !disabled, 
    [className]: className
  });

  return ( 
    <button 
      className={componentClass}
      disabled={!!disabled}
      {...props}
      ref={ref}
    >
      <>
        {spin && <Icon className="animate-spin" icon="spinner" size="1.4rem" />}
        {children}
      </>
      
    </button>
  );
});

Button.propTypes = {
  fullwidth: PropTypes.bool,
  height: PropTypes.number,
  pulse: PropTypes.bool,
  pulseDuration: PropTypes.number,
  pulseScale: PropTypes.number,
  pulseType: PropTypes.oneOf(["ease-in-out"])
};

export default Button;
